import { VApp } from 'vuetify/lib/components/VApp';
import { VMain } from 'vuetify/lib/components/VMain';

var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.authenticated)?_c('div',[_c(VApp,[(_vm.showHeader)?_c('Header',{ref:"childComponent",attrs:{"clipped":true,"drawer":false,"fixed":true,"title":_vm.title}}):_vm._e(),_c(VMain,[_c('search-menu',{attrs:{"showSearchMenu":_vm.showSM}}),_c('router-view')],1),_c('VersionModal',{model:{value:(_vm.showVersionModal),callback:function ($$v) {_vm.showVersionModal=$$v},expression:"showVersionModal"}})],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }